<div [innerHTML]="svgContent" [ngStyle]="getSvgStyle()"></div>
